import { render } from "./Numbers.vue?vue&type=template&id=938a5130&scoped=true"
import script from "./Numbers.vue?vue&type=script&lang=js"
export * from "./Numbers.vue?vue&type=script&lang=js"

import "./Numbers.vue?vue&type=style&index=0&id=938a5130&scoped=true&lang=css"

import exportComponent from "C:\\Users\\satish\\Desktop\\WEBDEV\\assignment\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-938a5130"]])

export default __exports__